module.exports = __webpack_public_path__ + "img/top-agente.78ec3de4.jpg";